import { omit } from 'lodash'
import { Variant } from 'react-bootstrap/types'

export type TPropsToVariant = {
  primary?: boolean
  secondary?: boolean
  danger?: boolean
  success?: boolean
  warning?: boolean
  light?: boolean
  dark?: boolean
  info?: boolean
  variant?: string
  blue?: boolean
}

export function propsToVariant(
  props: TPropsToVariant,
  defaultProp?: string,
): Variant {
  const {
    primary,
    secondary,
    danger,
    success,
    warning,
    light,
    dark,
    info,
    variant,
    blue,
  } = props
  if (variant) return variant
  if (primary) return 'primary'
  if (secondary) return 'secondary'
  if (danger) return 'danger'
  if (success) return 'success'
  if (warning) return 'warning'
  if (info) return 'info'
  if (light) return 'light'
  if (dark) return 'dark'
  if (blue) return 'blue'
  return defaultProp || 'light'
}

export function omitVariantProps(props: any): any {
  const {
    primary,
    secondary,
    danger,
    success,
    warning,
    light,
    dark,
    info,
    variant,
    blue,
    ...rest
  } = props
  return rest
}

export type TPropsToSize = {
  small?: boolean
  sm?: boolean
  large?: boolean
  lg?: boolean
  extrasmall?: boolean
  xs?: boolean
}

export function propsToSize(props: TPropsToSize): string {
  if (props.small || props.sm) return 'sm'
  if (props.large || props.lg) return 'lg'
  if (props.extrasmall || props.xs) return 'xs'
  return ''
}
